import { Injectable, inject } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';
import { Environment } from '@rma/generic/util/environment';

interface GtagWindow extends Window {
  gtag: (a: string, b: string, c: unknown) => void;
}

@Injectable({
  providedIn: 'root',
})
export class GoogleAdConversionTrackerService {
  private readonly environment = inject(Environment);
  private readonly window = inject<GtagWindow>(WA_WINDOW);

  public trackContactFormCompletionAdConversion() {
    this.trackAdConversion(
      this.environment.tracking.googleGlobalSiteTag?.adConversionId,
      this.environment.tracking.googleGlobalSiteTag?.contactFormCompletionAdConversionLabel,
    );
  }

  public trackSmsClickAdConversion() {
    this.trackAdConversion(
      this.environment.tracking.googleGlobalSiteTag?.adConversionId,
      this.environment.tracking.googleGlobalSiteTag?.smsClickAdConversionLabel,
    );
  }

  public trackCallClickAdConversion() {
    this.trackAdConversion(
      this.environment.tracking.googleGlobalSiteTag?.adConversionId,
      this.environment.tracking.googleGlobalSiteTag?.callClickAdConversionLabel,
    );
  }

  public trackPhoneRevealAdConversion() {
    this.trackAdConversion(
      this.environment.tracking.googleGlobalSiteTag?.adConversionId,
      this.environment.tracking.googleGlobalSiteTag?.phoneRevealAdConversionLabel,
    );
  }

  private trackAdConversion(conversionId?: string, conversionLabel?: string) {
    if (!this.window || !this.window.gtag) return;

    if (conversionId && conversionLabel) {
      this.window.gtag('event', 'conversion', {
        send_to: `${conversionId}/${conversionLabel}`,
        event_callback: () => {
          // if (url) {
          //   // this.window.location.href = url;
          // }
        },
      });
    }
  }
}

// For reference, below is what google provided us to get google tag conversions working

// In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button. -->
// <script>
// function gtag_report_conversion(url) {
//   var callback = function () {
//     if (typeof(url) != 'undefined') {
//       window.location = url;
//     }
//   };
//   gtag('event', 'conversion', {
//       'send_to': 'AW-867889263/oUMyCNK66O8CEO_g650D',
//       'event_callback': callback
//   });
//   return false;
// }
// </script>
